import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_183: DocMigration = {
  maxSchemaVersion: "0.0.183",
  description: "Resize studio preview text box sizes",
  apply(json: any) {
    for (const annotationId in json.annotation) {
      const annotation = json.annotation[annotationId];
      if (annotation.type === "NOTE") {
        annotation.textBoxWidth *= 1.265;
        annotation.textBoxHeight *= 1.265;
      }
    }
    return json;
  },
};

export default migration_0_0_183;
